module.exports = __webpack_public_path__ + "img/EMR-Logo.030d3cc9.png";